module.exports = __webpack_public_path__ + "assets/img/2016_1.45b78ad1.png";